// de_pms_reservations.ts
// Tłumaczenia dla PMS.Reservations.tsx i PMS.Reservations.Table.tsx

export const dePmsReservations = {

  summary: {
    total: "<strong>{{count}}</strong> gesamt",
    checkedIn: "<strong>{{count}}</strong> eingecheckt",
    arrivingToday_one: "<strong>{{progress}}</strong> Anreise heute",
    arrivingToday_other: "<strong>{{progress}}</strong> Anreisen heute",
  },
  wizard: {
    review: {
      documentChecked: "Dokument geprüft",
      vipLevel: "VIP-Stufe",
      marketing: "Marketing-Einwilligung",
      agreed: "Zugestimmt",
      declined: "Abgelehnt",
      extras: "Zusatzleistungen",
      cityTax: "Kurtaxe",
      deposit: "Anzahlung",
      blockPackages: "Blockpakete",
    },
    selectedRooms_one: "Ausgewählt: {{count}} Zimmer.",
    selectedRooms_other: "Ausgewählt: {{count}} Zimmer.",
    suitableRooms_one: "Nur Zimmer für {{count}} Gast anzeigen",
    suitableRooms_other: "Nur Zimmer für {{count}} Gäste anzeigen",
    groupRoomsSummary: "Gruppe · {{rooms}}: {{numbers}}",
    groupOccupancyHint: "Xentros verteilt die Gäste automatisch auf die Zimmer. Die Aufteilung kann geändert werden; die Gesamtzahlen müssen gleich bleiben: Erwachsene: {{adults}}, Kinder: {{children}}.",
  },

  title:     "Reservierungen",
  search:    "Gast oder ID suchen...",

  // ── Akcje ─────────────────────────────────────────────────────────────────
  actions: {
    newReservation:     "Neue Reservierung",
    modifyReservation:  "Reservierung ändern",
    modify:             "Ändern",
    cancelReservation:  "Reservierung stornieren",
    confirmCancellation:"Stornierung bestätigen",
    save:               "Speichern",
    saving:             "Wird gespeichert...",
    cancelling:         "Stornieren...",
  },

  // ── Filtry statusów ───────────────────────────────────────────────────────
  status: {
    all:        "Alle",
    confirmed:  "Bestätigt",
    inHouse:    "Im Haus",
    checkedOut: "Abgereist",
    cancelled:  "Storniert",
    noShow:     "No-Show",
    pending:    "Ausstehend",
    waitlist:   "Warteliste",
    planned:    "Geplant",
    completed:  "Abgeschlossen",
    booked:     "Gebucht",
    active:     "Aktiv",
    blocked:    "Gesperrt",
    departing:  "Abreise heute",
    authorized: "Autorisiert",
    captured:   "Eingezogen",
    inProgress: "In Bearbeitung",
  },

  // ── Typy rezerwacji ───────────────────────────────────────────────────────
  type: {
    individual: "Einzelreservierung",
    group:      "Gruppe",
    shared:     "Geteilt",
    direct:     "Direkt",
  },

  // ── Pola formularza ───────────────────────────────────────────────────────
  fields: {
    guest:      "Gast",
    room:       "Zimmer",
    checkIn:    "Check-in",
    checkOut:   "Check-out",
    nights:     "Nächte",
    adults:     "Erwachsene",
    children:   "Kinder",
    rate:       "Rate",
    total:      "Gesamt",
    deposit:    "Anzahlung",
    balance:    "Saldo",
    notes:      "Notizen",
  },

  // ── Sekcja historii ───────────────────────────────────────────────────────
  history: {
    title:      "Reservierungshistorie",
    auditTrail: "Audit-Trail für diese Reservierung.",
    captured:   "Aus der Reservierungsverwaltung übernommen.",
  },

  // ── Grupy rezerwacji ──────────────────────────────────────────────────────
  groups: {
    title:           "Gruppen und Veranstaltungen",
    summary:         "Gruppenübersicht",
    create:          "Gruppe erstellen",
    edit:            "Gruppe bearbeiten",
    save:            "Gruppe speichern",
    newReservation:  "Neue Gruppenreservierung",
    editReservation: "Gruppenreservierung bearbeiten",
    groupedRooms:    "Gruppenzimmer",
    linkedEvents:    "Verknüpfte Veranstaltungen",
    primaryEvent:    "Hauptveranstaltung",
    setPrimary:      "Als Hauptveranstaltung festlegen",
    masterDetails:   "Hauptdetails und Primärkontakt.",
    optionalEvents:  "Optionale Veranstaltungen zur Gruppenreservierung.",
    editInline:      "Reservierungsdetails direkt bearbeiten, ohne den Arbeitsbereich zu verlassen.",
    createTrack:     "Gruppenreservierungen und verknüpfte Veranstaltungen in einer Ansicht erstellen und verfolgen.",
    saved:           "Gruppenreservierung gespeichert",
    updated:         "Gruppenreservierung aktualisiert",
  },

  // ── Overbooking ───────────────────────────────────────────────────────────
  overbooking: "Überbuchungskontrolle",

  // ── Lista oczekujących ────────────────────────────────────────────────────
  waitlistMissingGuest: "Der Wartelisteneintrag enthält kein Gästeprofil.",

  // ── Typy wydarzeń ─────────────────────────────────────────────────────────
  eventTypes: {
    meeting:       "Meeting",
    conference:    "Konferenz",
    banquet:       "Bankett",
    wedding:       "Hochzeit",
    corporateEvent:"Firmenveranstaltung",
    other:         "Sonstiges",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    saved:                "Reservierung aktualisiert",
    cancelled:            "Reservierung storniert",
    correctionRequired:   "Bitte beheben Sie die markierten Reservierungsfehler.",
    groupCorrectionRequired:"Bitte beheben Sie die markierten Gruppenreservierungsfehler.",
    noEmail:              "Keine Empfänger-E-Mail-Adresse für diese Reservierung.",
    confirmationSent:     "Bestätigungs-E-Mail gesendet.",
    depositCaptured:      "Anzahlung eingezogen.",
  },

} as const;

export default dePmsReservations;
